export const LINKS = {
    LOGIN: '/login',
};
//# sourceMappingURL=links.js.map